module.exports = __webpack_public_path__ + "media/images/saved-ef225a88465f6d2fcbb9a28c190d181c.svg";